<template>  
  <div>
    <!-- ================= FILTER ================= -->
    <v-card flat>      
      <v-expansion-panels v-model="panel" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            Select Condition
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-row dense align="center">

              <!-- DATE -->
              <v-col cols="6" md="3" lg="2">
                <DxDateBox
                  label="From date"
                  :value="stDate"
                  display-format="yyyy-MM-dd"
                  @value-changed="e => stDate = e.value && getStrFormat(e.value)"
                />
              </v-col>

              <v-col cols="6" md="3" lg="2">
                <DxDateBox
                  label="To date"
                  :value="edDate"
                  display-format="yyyy-MM-dd"
                  @value-changed="e => edDate = e.value && getStrFormat(e.value)"
                />
              </v-col>

              <!-- STATUS -->
              <v-col cols="12" md="3">
                <v-row dense>
                  <v-col
                    v-for="s in statusList"
                    :key="s.model"
                    cols="3"
                  >
                    <v-checkbox
                      v-model="this[s.model]"
                      :label="s.label"
                      :color="s.color"
                      x-small
                    />
                  </v-col>
                </v-row>
              </v-col>

              <!-- SELECT -->
              <v-col
                v-for="s in selectList"
                :key="s.label"
                cols="6"
                md="3"
                lg="2"
              >
                <v-select
                  :label="s.label"
                  v-model="this[s.key]"
                  :items="getSelectItems(s.key)"
                  return-object
                  outlined
                  dense
                />
              </v-col>

            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <!-- SEARCH BUTTON -->
      <v-btn
        v-show="!isMobileDevice"
        fab
        absolute
        top
        right
        @click="btnRetrieve"
      >
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
    </v-card>

    <!-- ================= TABLE ================= -->
    <v-card class="mt-2">
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          hide-details
        />
      </v-card-title>

      <v-data-table
        :items="gridMainList"
        :headers="headers"
        :search="search"
        :items-per-page="listSize"
        :mobile-breakpoint="800"
        :height="isMobileDevice ? undefined : 600"
        dense
        :dark="dark"
        fixed-header
        class="mobile-clean-table"
      >
        <template v-slot:item="{ item, isMobile }">

          <!-- MOBILE -->
          <mobile-card-item
            v-if="isMobile"
            :item="item"
            :header-value="item.rno"
            :fields="mobileFields"
          >
            <template #details>
              <v-btn x-small color="primary" @click="showDetailComment(item)">
                Detail
              </v-btn>
            </template>

            <template #action1>
              <action-block
                :name="item.nm1st"
                :status="item.statNm1"
                :color="setColorStatus(item.rstatCd)"
                @click="showItemAction(item, -1)"
              />
            </template>

            <template #action2>
              <action-block
                v-if="item.nm2nd"
                :name="item.nm2nd"
                :status="item.statNm2"
                :color="setColorStatus(item.cstatCd)"
                @click="showItemAction(item, 1)"
              />
            </template>

            <template #subject>
              <a @click="subjectShow(item)">
                {{ item.subject }}
              </a>
            </template>
          </mobile-card-item>

          <!-- PC -->
          <tr v-else class="custom-pc-row">
            <td class="text-center">
              <v-chip small outlined :color="getColor(item.rno)">
                {{ item.rno }}
              </v-chip>

              <v-btn
                x-small
                color="primary"
                class="ml-2"
                @click="showDetailComment(item)"
              >
                Detail
              </v-btn>
            </td>

            <td class="text-center">{{ item.shipNo }}</td>
            <td class="text-center">{{ item.statNm }}</td>
            <td class="text-center">{{ item.issueRefDoc }}</td>

            <td>
              <action-block
                :name="item.nm1st"
                :status="item.statNm1"
                :color="setColorStatus(item.rstatCd)"
                @click="showItemAction(item, -1)"
              />
            </td>

            <td>
              <action-block
                v-if="item.nm2nd"
                :name="item.nm2nd"
                :status="item.statNm2"
                :color="setColorStatus(item.cstatCd)"
                @click="showItemAction(item, 1)"
              />
            </td>

            <td>
              <a @click="subjectShow(item)">
                {{ item.subject }}
              </a>
            </td>

            <td class="text-center">{{ item.regDt }}</td>
            <td>{{ item.issueOfcr }}</td>
            <td>{{ item.regEmpnoNm }}</td>
            <td class="text-center">{{ item.evtNm }}</td>
            <td>{{ item.rsnNm }}</td>
          </tr>

        </template>
      </v-data-table> 
      <!-- For Show Dialog             -->
      <!-- <template>
        <div> -->
          <!-- ================= ACTION DIALOG ================= -->
          <BaseDialog v-model="dialogAction" :title="formTitle" width="1000">
            <v-data-table
              :headers="dialogActionHeaders"
              :items="dialogActionList"
              :mobile="mobile"
              :dense="true"
              hide-default-footer
            >
              <template #item="{ item, isMobile }">
                <mobile-card-item
                  v-if="isMobile"
                  :item="item"
                  :header-value="item.rno"
                  :fields="dialogActionHeadersMobileFields"
                />
                <tr v-else class="custom-pc-row">
                  <td class="text-center">{{ item.rNo }}</td>
                  <td class="text-center">{{ item.dlNm }}</td>
                  <td class="text-center">{{ item.issueDt }}</td>
                  <td class="text-center">{{ item.cnfmDt }}</td>
                  <td class="text-center">{{ item.trgtDt }}</td>
                  <td class="text-center">{{ item.prodStopDt }}</td>
                  <td class="text-center">{{ item.stopDt }}</td>
                  <td class="text-center">{{ item.cntDays }}</td>
                </tr>
              </template>
            </v-data-table>
          </BaseDialog>

          <!-- ================= SUBJECT ================= -->
          <BaseDialog v-model="dialogSubject" title="Description" width="800">
            <div class="pa-3 font-weight-bold">
              {{ formSubjectTitle }}
            </div>
          </BaseDialog>

          <!-- ================= DETAIL ================= -->
          <v-dialog v-model="dialogDetail" scrollable persistent>
            <v-card
              v-for="item in gridDetailList"
              :key="item.rno"
              class="mb-4"
            >
              <!-- HEADER -->
              <v-card-title class="cyan darken-1 white--text">
                {{ item.rno }} - Detail Comment
                <v-spacer />
                <v-btn icon @click="dialogDetail = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>

              <v-card>
                <!-- TOP INFO -->
                <v-row class="pa-2 light-green accent-4">
                  <v-col cols="6">
                    <strong>Ship No:</strong> {{ item.shipNo }}
                  </v-col>
                  <v-col cols="6">
                    <strong>Comment No:</strong> {{ item.issueRefdoc }}
                  </v-col>
                </v-row>

                <!-- IMAGE -->
                <ImageSection
                  :item="item"
                  :content="content"
                  :viewer-options="viewerOptions"
                  @open-file="openFileDialog"
                />

                <!-- SUBJECT -->
                <ExpandableSection
                  v-if="expanded[item.rno]"
                  title="Subject"
                  :value="item.subject"
                  v-model="expanded[item.rno].content"
                >
                  <div class="pa-2 text-caption">
                    {{ item.description }}
                  </div>
                </ExpandableSection>

                <!-- QM -->
                <ExpandableSection
                  title="QM Input Comment"
                  v-model="expanded[item.rno].qm"
                >
                  <QmInfoSection :item="item" />
                </ExpandableSection>

                <!-- 1st -->
                <ActionSection
                  title="1st Action"
                  :item="item"
                  type="1"
                  v-model="expanded[item.rno].first"
                />

                <!-- 2nd -->
                <ActionSection
                  v-if="item.codeNm2"
                  title="2nd Action"
                  :item="item"
                  type="2"
                  v-model="expanded[item.rno].second"
                />
              </v-card>
            </v-card>
          </v-dialog>

          <!-- ================= FILE ================= -->
          <BaseDialog v-model="dialogFile" :title="fileTitle" width="500">
            <v-data-table
              :headers="dialogFileHeaders"
              :items="dialogFileList"
              dense
              hide-default-footer
            >
              <template v-slot: item.openFile="{ item }">
                <v-chip small @click="fileOpen(item)">Open file</v-chip>
              </template>
            </v-data-table>
          </BaseDialog>

          <!-- ================= IMAGE VIEW ================= -->
          <v-dialog v-model="dialogShowFile" fullscreen persistent>
            <v-card class="d-flex flex-column">
              <v-card-title class="cyan darken-1 white--text">
                {{ titleFileName }}
                <v-spacer />
                <v-btn icon @click="dialogShowFile = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>

              <v-card-text class="pa-0 flex-grow-1">
                <viewer :images="[content1]" :options="viewerOptions">
                  <img :src="content1" class="fit-image" />
                </viewer>
              </v-card-text>
            </v-card>
          </v-dialog>
        <!-- </div>
      </template>                 -->
    </v-card>
     <!-- ================= FLOAT BUTTON ================= -->
    <v-btn
      v-scroll="onScroll"
      v-show="fab && isMobileDevice"
      fab
      dark="dark"
      fixed
      bottom
      right
      color="primary"
      @click="toTop"
      style="z-index: 1000;"
    >
      <v-icon>mdi-chevron-up</v-icon>
    </v-btn>
  </div>  
</template>

<script>
  import  { mdiAccount, mdiPencil, mdiShareVariant,  mdiDelete,  mdiSelectSearch,  mdiMapSearch  } from '@mdi/js'

  import  { getShipList, 
            getQMPartList,
            getSecCommentList,
            getQmEmployeeList,
            getTelephoneList,
            getEventList,
            getDivList,
            getPublisherList,
        } from '@/api/view/tqm/80/v80comm.js'

  import  {
          v80d1010List,
          v80d1010DetailList,
          v80d1010DetailFileList
        } from '@/api/view/tqm/80/v80d1010.js'

  import DxDateBox from 'devextreme-vue/date-box'
  import baseview from '@/components/base/baseview.vue' // base page addition
  import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // Add base when using data grid
  import { mobileTableMixin } from '@/mixins/mobileTableMixin.js' // Import mixin mới
  import EventBus from '@/components/event-bus';
  
  import { DxScrollView } from "devextreme-vue/scroll-view";
  import { ftpDownload} from '@/api/view/tqm/common/common.js'
  import {ftpDownloadViewer} from "@/api/view/tqm/common/common.js";

  import { getDateFormat, } from '@/utils/common.js'
  import dayjs from 'dayjs';

  import BaseDialog from "@/components/base/BaseDialog.vue"
  import ExpandableSection from "@/components/base/ExpandableSection.vue"
  import QmInfoSection from "@/components/base/QmInfoSection.vue"
  import ActionSection from "@/components/base/ActionSection.vue"
  import ImageSection from "@/components/base/ImageSection.vue"

export default {
  name: "v80d1010",
  mixins: [baseview, BaseDataGrid, mobileTableMixin],
  components: {
    DxDateBox,
    DxScrollView,
    BaseDialog,
    ExpandableSection,
    QmInfoSection,
    ActionSection,
    ImageSection
  },
  data: () => ({
    expanded: {},
    Path : '',
    content:'',
    content1:'',
    showpdf: false,
    showpdf1: false,
    dark: false,
    isMobileDevice: false, // Biến mới
    fab: false,
    icons: {
      mdiAccount,
      mdiPencil,
      mdiShareVariant,
      mdiDelete,
      mdiSelectSearch,
      mdiMapSearch

    },
    // Popup
    makePop: false,
    // tooltip 
    subjectTitle:'',
    // Dialog
    dialogAction: false,
    dialogSubject: false,
    dialogDetail: false,
    dialogShowFile: false,
    titleFileName:'',
    editedIndex: -1,
    dialogActionList: [],
    titleActionDeptName:'',
    dialogDetailInputList:[],
    // Test Expansion panels
    // panel: [0, 1, 2],
    readonly: false,
    showContentComment: true,
    showQm: true,
    show1st: true,
    show2nd: true,
    show1stContent: false,
    show2ndContent:false,
    //File detail
    dialogFile: false,
    fileTitle:'',
    dialogFileHeaders: [
                      { text: 'No', align: 'center', value: 'rno', sortable: false, },
                      { text: 'File No', sortable: false, divider: true, align: 'center', value: 'imgNo',  },
                      { text: 'File type', sortable: false, divider: true, align: 'center', value: 'imgExt',  },
                      { text: 'Control file', sortable: false, divider: true, align: 'center', value: 'openFile',  },

    ],
    dialogFileList: [],
    //Detail
    dialogDetailInputHeaders:[],
    dialogActionHeaders: [
                { text: 'No', align: 'center', sortable: false, value: 'rno', divider: true, },
                { text: 'Delay name', align: 'center', sortable: false, value: 'dlNm', divider: true, },
                { text: 'Issue date', sortable: false, divider: true, align: 'center',value: 'issueDt', },
                { text: 'Close date', sortable: false, divider: true, align: 'center',value: 'cnfmDt', },
                { text: 'Target date', sortable: false, divider: true, align: 'center',value: 'trgtDt', },
                { text: 'Pro stop date', sortable: false, divider: true, align: 'center',value: 'prodStopDt', },
                { text: 'QM stop date', sortable: false, divider: true, align: 'center',value: 'stopDt', },
                { text: 'Count days', sortable: false, divider: true, align: 'center',value: 'cntDays', },
              
              ],
    dialogActionHeadersMobileFields: [
      // { label: 'No', key: 'rno' },
      { label: 'Delay name', key: 'dlNm' },
      { label: 'Issue date', key: 'issueDt' },
      { label: 'Close date', key: 'cnfmDt' },
      { label: 'Target date', key: 'trgtDt' },
      { label: 'Pro stop date', key: 'prodStopDt' },
      { label: 'QM stop date', key: 'stopDt' },
      { label: 'Count days', key: 'cntDays' },

    ],                

    stDate: '',
    edDate: '',
    shipNoList: [],
    shipNo: '',

    deptName: '',
    deptNameList: [],
    deptCd: '',
    sectCd: '',

    respClsName: '',
    respClsNameList: [],
    respCls: '',

    clsCd: '',
    publisherName:'',
    publisherNameList: [],

    empNo: '',
    empName: '',
    empNameList: [],

  
    panel: [0],
    disabled: false,
    hover: true,

    // data
    gridMainList: [],
    listSize: 0,
    gridDetailList: [],
    gridDetailFileList: [],
    
    mobile: true,
    search: '', 
    hide2ndAction: false,
    headers: [
                { text: 'No', sortable: false, align: 'center', value: 'details', divider: true,  },
                { text: 'Ship No', sortable: false, divider: true, align: 'center',value: 'shipNo', },
                { text: 'Status', sortable: false, divider: true, align: 'center',value: 'statNm', },
                { text: 'Comment No', sortable: false, divider: true, align: 'center',value: 'issueRefDoc', },
                { text: '1st Action', sortable: false, divider: true, align: 'center',value: 'action1', visible: 'true'  },
                { text: '2nd Action', sortable: false, divider: true, align: 'center',value: 'action2', visible: 'true' },
                { text: 'Subject', sortable: false, divider: true,align: 'center',value: 'subject',  },
                { text: 'Input Comment', sortable: false, divider: true,align: 'center',value: 'regDt',  },
                { text: 'Issue by', sortable: false, divider: true,align: 'center',value: 'issueOfcr',  },
                { text: 'QM PIC', sortable: false, divider: true,align: 'center',value: 'regEmpnoNm',  },
                { text: 'Main event', sortable: false, divider: true,align: 'center',value: 'evtNm',  },
                { text: 'Reason', sortable: false, divider: true,align: 'center',value: 'rsnNm',  },
              ],
    selectedRowIndex: null, // Lưu index của dòng đang được chọn 
    // Chỉ cần khai báo list này là giao diện tự sinh ra
    mobileFields: [
      { label: 'Action', key: 'details' },
      { label: 'Ship No', key: 'shipNo' },
      { label: 'Status', key: 'statNm' },
      { label: 'Comment No', key: 'issueRefDoc' },
      { label: '1st Action', key: 'action1' },
      { label: '2nd Actiont', key: 'action2' },
      { label: 'Subject', key: 'subject' },
      { label: 'Input Comment', key: 'regDt' },
      { label: 'Issue by', key: 'issueOfcr' },
      { label: 'QM PIC', key: 'regEmpnoNm' },
      { label: 'Main event', key: 'evtNm' },
      { label: 'Reason', key: 'rsnNm' },

    ],                        
    statusList : [
      { label: 'Not yet', color: 'red', model: 'statCd1' },
      { label: 'Receipt', color: 'indigo', model: 'statCd3' },
      { label: 'Reply final', color: 'green darken-1', model: 'statCd5' },
      { label: 'QM return', color: 'blue accent-4', model: 'statCd7' },
      { label: 'Final', color: 'amber', model: 'statCd9' },
      { label: 'Withdraw', color: 'orange', model: 'statCdCan' },
    ], 
    selectList: [
      { label: 'Ship No', key: 'shipNo', items: [] },
      { label: 'Publisher', key: 'publisherName', items: [] },
      { label: 'Division', key: 'respClsName', items: [] },
      { label: 'Department', key: 'deptName', items: [] },
      { label: 'Employee', key: 'empName', items: [] },
      ] ,
    statCd1:true,
    statCd3:true,
    statCd5:true,
    statCd6:true,
    statCd7:true,
    statCd8:true,
    statCd9:false,
    statCdCan:false,    
    viewerOptions: {
      toolbar: {
        zoomIn: 4,
        zoomOut: 4,
        oneToOne: 4,
        reset: 4,
        prev: 0, // Ẩn nút nếu chỉ có 1 ảnh
        play: { show: 4, size: 'large' },
        next: 0,
        rotateLeft: 4,
        rotateRight: 4,
        flipHorizontal: 4,
        flipVertical: 4,
      },
      inline: false,
      button: true,
      navbar: false, // Ẩn thanh danh sách ảnh bên dưới nếu chỉ xem 1 tấm
      title: false,
      tooltip: true,
      movable: true, // Cho phép kéo ảnh
      zoomable: true, // Cho phép zoom
      rotatable: true, // Cho phép xoay
      scalable: true, // Cho phép lật (mirror)    
      transition: true,
      fullscreen: true,
      keyboard: true,  
      viewed() {
        this.viewer.zoomTo(1); // Reset về tỉ lệ thực của ảnh hoặc...
        this.viewer.scale(1); // -1 Nếu cần lật ảnh
      },
    }
  }),
  computed: {
    formTitle () {
          return this.editedIndex === -1 ? '1st Action: '  + this.titleActionDeptName : '2nd Action: ' + this.titleActionDeptName
        },

    formSubjectTitle (){
      return this.subjectTitle
        } ,  
  },

  watch: {
    /*  options: {
    handler () {
      this.btnRetrieve()
    },
    deep: true,
  }, */
  },
  created() {
    EventBus.$on(this.$options.name + "_search", () => { 
      this.btnRetrieve();
    });
  },
  mounted() {
    this.init()
    //Apply for Fab
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);

    this.loadColumnWidths(); // Khôi phục ngay khi load trang
    
    // Lắng nghe sự kiện thả chuột để lưu lại kích thước mới
    this.$el.querySelector('.v-data-table').addEventListener('mouseup', () => {
      // Đợi một chút để trình duyệt cập nhật xong style.width
      setTimeout(() => {
        this.saveColumnWidths();
      }, 100);
    });
  
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
    EventBus.$off(this.$options.name + "_search");
  },
  methods: {            
      btnRetrieve() {
          this.gridMainList = []        
          this.getMainList()          
      },
      getStrFormat(date) {
        return getDateFormat(date)
      },
      init() {
        let toDay = new Date      
        this.stDate = toDay.setDate(toDay.getDate() - 1);
        toDay = new Date
        this.edDate = toDay.setDate(toDay.getDate() + 1);

        this.stDate = dayjs(this.stDate).format('YYYY-MM-DD')
        this.edDate = dayjs(this.edDate).format('YYYY-MM-DD')
        this.getList()

      },   
      getSelectItems(key) {
        switch (key) {
          case 'shipNo': return this.shipNoList
          case 'publisherName': return this.publisherNameList
          case 'respClsName': return this.respClsNameList
          case 'deptName': return this.deptNameList
          case 'empName': return this.empNameList
          default: return []
        }
      }, 
      //getList
      async getList() {
        try {
            this.openLoading('searching')
            let params = {
              cdDiv: '',
              respCd: '21%'
            }
            // Department Division
            await getDivList(params).then(res => {
              this.respClsNameList = ['All']
              // this.respClsNameList.push('All')
              (res.list || []).forEach(e => {
                this.respClsNameList.push(e.respCls + ' : ' + e.respClsNm)
              });
              this.respClsName = this.respClsNameList[0]
            })
            // getShipList
            await getShipList(params).then(res => {
                    this.shipNoList = ['All']
                    // this.shipNoList.push('All')
                    (res.list || []).forEach(e => {
                      this.shipNoList.push(e.shipNo)
                    });
                    this.shipNo = this.shipNoList[0]
                  })
            // Section Department
            await getSecCommentList(params).then(res => {
                    this.deptNameList = ['All']
                    // this.deptNameList.push('All')
                    (res.list || []).forEach(e => {
                      this.deptNameList.push(e.sectCd + ' : ' + e.sectNm)
                    });
                    this.deptName = this.deptNameList[0]
                  })        

            // Publisher
            await getPublisherList(params).then(res => {
              this.publisherNameList = ['All']
              // this.publisherNameList.push('All')
              (res.list || []).forEach(e => {
                this.publisherNameList.push(e.clsCd + ' : ' + e.clsNm)
              });
              this.publisherName = this.publisherNameList[0]
            })
            // QM PIC List
            await getQmEmployeeList(params).then(res => {
              this.empNameList = ['All']
              // this.empNameList.push('All')
              (res.list || []).forEach(e => {
                this.empNameList.push(e.empNo + ' : ' + e.empNm)
              });
              this.empName = this.empNameList[0]
            })

            // bind lại selectList items
            this.selectList.find(s => s.key === 'shipNo').items = this.shipNoList
            this.selectList.find(s => s.key === 'publisherName').items = this.publisherNameList
            this.selectList.find(s => s.key === 'respClsName').items = this.respClsNameList
            this.selectList.find(s => s.key === 'deptName').items = this.deptNameList
            this.selectList.find(s => s.key === 'empName').items = this.empNameList
            
            } finally {
                this.endLoading()
            }

      },
      async getMainList() {
          try {
              this.openLoading('searching') 
              
              this.respCls = (this.respClsName || '').split(' : ')[0]
              this.clsCd = (this.publisherName || '').split(' : ')[0]
              this.sectCd = (this.deptName || '').split(' : ')[0]
              this.empNo  = (this.empName || '').split(' : ')[0]
              let params = {
                shipNo: this.shipNo === 'All' ? '' : this.shipNo,
                clsCd: this.clsCd ==='All' ? '' : this.clsCd,
                respCls: this.respCls === 'All' ? '' : this.respCls,
                sectCd: this.sectCd === 'All' ? '%' : this.sectCd,
                deptCd:  this.sectCd === 'All' ? '' : this.sectCd.substring(0,2),
                statCd1: this.statCd1 === true ? '1' : '',
                statCd3: this.statCd3 === true ? '3' : '',
                statCd5: this.statCd5 === true ? '5' : '',
                statCd6: this.statCd7 == true ? '6' : '',
                statCd7: this.statCd7 == true ? '7' : '',
                statCd8: this.statCd5 === true ? '8' : '',
                statCd9: this.statCd9 == true ? '9' : '',
                statCdCan: this.statCdCan === true ? 'C' : '',
                stDate: this.stDate,
                edDate: this.edDate,
                empNo: this.empNo === 'All' ? '' : this.empNo

              }
              await v80d1010List(params).then(res => {
                let list = []
                let cnt = 1;
                  (res.list || []).forEach(e => {
                    // e.shipNo,e.clsCd,e.cmtSeq,e.statCd,e.subject ,e.issueOfcr, e.issueDt,e.issueDt1,e.passday, e.regEmpno,e.regDt,e.deptCd,e.rsnCd, e.description,
                    // e.codeNm,e.nm1st,e.replyCtnt1,e.replyCtnt2,e.rrespCd, e.rstatCd, e.rchkDt, e.crespCd,e.cstatCd,e.cchkDt,e.respChgReq, e.rcnfmDt,e.ccnfmDt,
                    // e.rregDt,e.cregDt,e.dlCd,e.dlCd1,e.prodStopdt,e.prodStopdt1,e.stopDt, e.stopDt1,e.matDt,e.matDt1,e.cntDays,e.cntDays1,e.cnfmDt,e.cnfmOfcr,
                    // e.issueRefDoc,e.rremark,e.cremark,e.ord,e.importantYn,e.qmPart, e.hvsYn,e.block,e.matlDly,e.trgtDt,e.trgtDt2,e.cprodYn,e.rprodYn,e.cmatYn,
                    // e.rmatYn,e.cnf2Yn,e.qmGrp, e.dlyDay,e.mevt,e.evtNm,e.statNm,e.statNm1,e.rsnNm,e.regEmpnoNm,e.dlNm,e.dlNm1,
                    list.push({
                      ...e,
                      rno: cnt++,
                      nm2nd: e.nm2nd === null ? '' : e.nm2nd,
                      statNm2: e.statNm2===null ?'': e.statNm2,
                    })
                    
                  });

                  this.gridMainList = list
                  this.listSize = this.gridMainList.length;

                  if (this.listSize > 0 && this.isMobileDevice) {
                    this.panel = [];
                  }
              })

          } finally {
              this.endLoading()
          }
      },

      async getDetailList(obj) {
          try {
              this.openLoading('searching') 
              let params = {
                shipNo: obj.shipNo,
                clsCd: obj.clsCd,
                cmtSeq: obj.cmtSeq,
              }  
              await v80d1010DetailList(params).then(res => {
                let list = []
                  (res.list || []).forEach(e => {
                    // Show file JPG
                    if(e.imgNo != null){
                      this.Path = 'attachfile/QC/COMMENT/'+ e.imgNo + '.' + e.imgExt;
                      var dirs = this.Path.split('/');    
                      var t1 =  dirs[dirs.length - 1];
                      var fname = t1.split('.');
                      var extend = fname[1];
                      var datatype = "";
                      fname = fname[0].replace(/ /g, "")
                      if(extend.toUpperCase() === 'PDF'){
                        datatype = "data:application/pdf;base64,";
                        this.showpdf = true;
                      }
                      else{
                        datatype = "data:image/" + extend + ";base64,";
                        this.showpdf = false;
                      }
                      ftpDownloadViewer(this.Path, fname).then((res) =>{        
                        this.content = datatype + res.body;
                      }).catch(error => {
                        alert('This file is not existed. Please contact HVS PIC!');
                      })
                      .finally(() => {
                      })
                    }                   
                    // obj.rno,e.shipNo,e.clsCd,e.clsNm,e.cmtSeq,e.rsnCd,e.rsnNm,e.issueCls,e.complyCd,e.wkKind,e.stgCd,e.block, e.issueDt,e.cmtYn, e.issueDt2,e.regDt,e.cnfmDt,
                    // e.cnfmDt2,e.qmCnfmDt,e.qmCnfmDt2, e.prodStopDt1,e.prodStopDt2,e.prodStopEmp1,e.prodStopEmp2,e.matArrDt1,e.matArrDt2,e.matArrEmp1,e.matArrEmp2,
                    // e.delayStopDte1,e.delayStopDte2,e.delayArriDte1,e.delayArriDte2,e.regEmpno,e.regEmpnoNm, e.tel,e.issueOfcr,e.cnfmOfcr, e.cnfmOfcr2,e.ncrCode,
                    // e.issueRefdoc,e.issueRefinfo,e.location,e.subject,e.description,e.suggestion, e.seriesYn,e.cmtnoCd,e.issueDoc3,e.drawNo,e.ownsDocno,e.issueBy,
                    // e.importantYn,e.imgNo,e.fileName,e.imgExt,e.showImg,e.dwgFile,e.replyEmpno,e.replyEmpnoNm1,e.replyEmpno2,e.replyEmpnoNm2,e.respCls,e.gbanCd,
                    // e.gbanCd2,e.respCd,e.deptNm1,e.respCd2,e.deptNm2, e.jumuYn,e.jumuYn2,e.statCd,e.statNm1,e.statCd2,e.statNm2,e.respchgReq,e.replyDt,e.replyDt2,
                    // e.replyCtnt,e.replyCtnt2,e.remark,e.remark2,e.codeNm,e.codeNm2,e.deptSect1,e.deptSect2,e.recvDt,e.acptYn,e.replyTel,e.chkEmpno,e.chkDt,e.matlDly,
                    // e.matlDly,e.matrDate,e.qmPart,e.qmPartNm,e.hvsYn,e.qmYn,e.haveYn,e.chkYn,e.dsnYn,e.cmtnoDoc1,e.cmtnoDoc2,e.trgtDt,e.trgtDt2,e.mainSta,e.dlyCd1,e.dlyNm1,
                    // e.dlyCd2,e.dlyNm2,e.rplyCd1, e.rplyNm1,e.rplyCd2,e.rplyNm2,e.owner,e.prodDiv1st,e.hotWk,e.majYn,e.weekYn,e.prodYn1,e.prodYn2,e.matArrYn1, e.matArrYn2,
                    // e.qmApprStopStat1, e.qmApprStopStat2,e.evtNm,e.stopRsnCd,e.stopRsnNm,e.stopRsnCd2,e.stopRsnNm2,e.qmApprStopDte1,e.qmApprStopDte2,e.porNo,e.msys,e.lsys,
                    // e.ssys,e.mevt,e.cntImgDsn,e.cntImgQm,e.cntImgPro,
                    list.push({
                      ...e,
                      rno: cnt++, // ✅ THÊM DÒNG NÀY
                      regFull: e.regEmpno + ': ' + e.regEmpnoNm, 
                    })
                    
                  });
                  this.gridDetailList = list
                  // 👉 THÊM ĐOẠN NÀY
                  list.forEach(item => {
                    if (!this.expanded[item.rno]) {
                      this.$set(this.expanded, item.rno, {
                        content: false,
                        qm: false,
                        first: false,
                        second: false
                      })
                    }
                  })
              })

          } finally {
              this.endLoading()
          }
      },
    
    //File list
    async initialize (obj, div) {
        try {
              this.openLoading('searching') 
              let params = {                
                  shipNo: obj.shipNo,
                  clsCd: obj.clsCd,
                  cmtSeq: obj.cmtSeq,
                  div: div
              }
              await v80d1010DetailFileList(params).then(res => {
                let list = []
                let cnt = 1
                  (res.list || []).forEach(e => {
                    list.push({
                      rno: cnt++,
                      imgNo: e.imgNo,
                      fileName: e.fileName,
                      imgExt: e.imgExt,
                      div: e.div
                    })                    
                  });

                  this.dialogFileList = list
              })

          } finally {
              this.endLoading()
          }
      
    },
    getColor (value) {
        if (value > 40) return 'red'
        else if (value > 20) return 'orange'
        else return 'green'
    },  
    setColorStatus (str) {
        if (str === '1') return 'red'
        else if (str === '3') return 'indigo'
        else if (str === '5'||str === '8') return 'green darken-1'
        else if (str === '6'||str === '7') return 'blue'
        else if (str === '9') return 'amber'
        else return 'orange'
    },  
    showItemAction(e, index){
      this.editedIndex = index
      if(index === -1){
        this.titleActionDeptName = e.nm1st
        this.dialogActionList = [{rno: 1, dlNm: e.dlNm, issueDt: e.issueDt,  cnfmDt: e.rcnfmDt,   trgtDt: e.trgtDt,  prodStopDt: e.prodStopdt,   stopDt:e.stopDt,  cntDays: e.cntDays},]
      }else{
        this.titleActionDeptName = (e.nm2nd === null ? '' : e.nm2nd)
        this.dialogActionList = [{rno: 1, dlNm: e.dlNm1, issueDt: e.issueDt1, cnfmDt: e.ccnfmDt, trgtDt: e.trgtDt2,  prodStopDt: e.prodStopdt1,  stopDt: e.stopDt1,  cntDays: e.cntDays1},]
      }
      this.dialogAction = true
    },

    subjectShow(e){
      this.subjectTitle = (e.description === null ? '' : e.description)   
      this.dialogSubject = true
    },

    async showDetailComment(e){
      await this.getDetailList(e)
      this.showQm = true
      this.show1st = true
      this.show2nd = true
      this.dialogDetail = true 
      this.showContentComment = true 
    },

    //openFileDialog
    openFileDialog (item, div) {
      if(div==='R'){
        this.fileTitle = 'Design attach file'
      }else if(div==='A'){
        this.fileTitle = 'Production attach file'
      }      
      else{
        this.fileTitle = 'QM attach file'
      }
      if(item.cntImgDsn > 0 || item.cntImgQm > 0 || item.cntImgPro > 0){
        this.initialize(item, div)
        this.dialogFile = true
      }else{
        this.vToastify(this.$t('Sorry!, No attach file!'), 'warn')
        this.dialogFile = false
      }
    },

    fileOpen(e){
        this.dialogShowFile = true
        this.titleFileName = e.imgNo + '.' + e.imgExt;
        let dirPath = 'attachfile/QC/COMMENT/';
        let fileType = e.imgExt;
        let filePath = dirPath + e.imgNo + '.' + fileType;

        var dirs = fileType.split('/');    
        var t1 =  dirs[dirs.length - 1];
        var fname = t1.split('.');
        var datatype = "";
        fname = fname[0].replace(/ /g, "")
        if(fileType.toUpperCase() ==='PDF'){
          datatype = "data:application/pdf;base64,";
          this.showpdf1 = true;
          this.openLoading('searching')
          ftpDownload(filePath, e.imgNo)
          .finally(() => {
            this.endLoading()
          })          
        }else{
          datatype = "data:image/" + fileType + ";base64,";
          this.showpdf1 = false;

          this.openLoading('searching')
          ftpDownloadViewer(filePath, fname).then((res) =>{
            this.content1 = datatype + res.body;
          }).catch(error => {
            alert('This file is not existed. Please contact HVS PIC!');
          })
          .finally(() => {
            this.endLoading()
          })
        } 
    },

    // Hàm lưu độ rộng vào localStorage
    saveColumnWidths() {
      const widths = {};
      const ths = this.$el.querySelectorAll('.v-data-table th');      
      ths.forEach((th, index) => {
        // Lưu theo index hoặc value của header để không bị lẫn
        widths[index] = th.style.width;
      });
      
      localStorage.setItem(`table_width_${this.$options.name}`, JSON.stringify(widths));
    },

    // Hàm khôi phục độ rộng khi vào lại trang
    loadColumnWidths() {
      const savedWidths = localStorage.getItem(`table_width_${this.$options.name}`);
      if (savedWidths) {
        const widths = JSON.parse(savedWidths);
        this.$nextTick(() => {
          const ths = this.$el.querySelectorAll('.v-data-table th');
          ths.forEach((th, index) => {
            if (widths[index]) {
              th.style.width = widths[index];
            }
          });
        });
      }
    },

  },

};
</script>
<style>
@import "~@/assets/css/mobile-table.css";

/* ===== Layout ===== */
.border-bottom {
  border-bottom: 1px dashed #eee;
}

.v-card__text {
  max-height: 70vh;
}

/* ===== Image ===== */
.custom-pc-row td .v-image__image {
  background-size: contain !important;
}

.cursor-pointer {
  cursor: zoom-in !important;
  transition: opacity 0.3s;
}

.cursor-pointer:hover {
  opacity: 0.8;
}

/* ===== Icon ===== */
.pdf-icon-btn {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.pdf-icon-btn:hover {
  transform: scale(2);
  color: #d32f2f !important;
}

.pdf-icon-btn:active {
  transform: scale(1.1);
  opacity: 0.7;
}

/* ===== Input ===== */
.v-input--selection-controls__input {
  margin-right: 1px !important;
}

.v-input--selection-controls .v-label {
  font-size: 13px !important;
}

/* ===== Viewer ===== */
.viewer-container-class {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #000;
}

.fit-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
</style>